import React from 'react';
import { useAppStoreDispatch, useAppStoreSelector } from '../../../store/index';
import { useTranslation } from 'react-i18next';
import FormEL, { Fields } from '../../general/components/Form';
import { loginThunk } from '../store/userSlice';
// import { useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { useToast } from '../../general/components/Toast.hook';
import * as yup from 'yup';
import RememberMe from '../../general/components/RemembemMe';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import { attachTokenInterceptor } from '../../../utils/api/axiosInstance';

export default function LoginForm() {
  const fields: Fields[] = [
    {
      id: 'email',
      label: 'auth.usernameOrEmail',
      type: 'text',
      validator: yup.string().min(1).required(),
    },
    {
      id: 'password',
      label: 'auth.password',
      type: 'password',
      validator: yup.string().min(1).required(),
    },
  ];

  const [getValuesRef, setGetValuesRef] = React.useState<(() => any) | null>(null)
  const [rememberMe, setRememberMe] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const config = useAppStoreSelector((state) => state.config);
  const [triggerMessage] = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useAppStoreDispatch();
  const appSettings = useAppStoreSelector((state) => state.settings);
  let redirect = searchParams.get("redirect");
  let shareParam = searchParams.get("share");
  let keyParam = searchParams.get("key");

  // useEffect(() => {
  //   const publicKey = config.data?.authConfig.jwtPublicKey;
  //   if (token && expirationDate && publicKey) {
  //     dispatch(addUserData({ token, publicKey }));
  //     if (rememberMe) {
  //       User.persistUser(token);
  //       // navigate('/');
  //     }
  //     eraseTokenCookie();
  //     eraseExpirationDateCookie();
  //     console.log('Token attach2: ', token);
  //     attachTokenInterceptor(token);
  //   }
  // }, [token]);

  const handleLogin = async (credentials: {
    email: string;
    password: string;
  }) => {
    setLoading(true);
    try {
      await dispatch(loginThunk({ credentials, rememberMe })).unwrap();

      // Construct redirect URL with share or key parameters if present
      let redirectUrl = redirect || '/';
      if (redirect) {
        const params = [];
        if (shareParam) params.push(`share=${shareParam}`);
        if (keyParam) params.push(`key=${keyParam}`);
        if (params.length > 0) {
          const separator = redirect.includes('?') ? '&' : '?';
          redirectUrl = `${redirect}${separator}${params.join('&')}`;
        }
      }

      navigate(redirectUrl);
    } catch (error) {
      console.log(error);
      console.log(error instanceof AxiosError);
      const errorType = error as AxiosError;
      const errorMessage = errorType.message;
      triggerMessage(errorMessage, true);
    } finally {
      setLoading(false);
    }
  };

  const { t } = useTranslation();

  const onRememberMeCheckChangeHandler = () => {
    setRememberMe((prevValue) => !prevValue);
  };

  const handleForgotPasswordClick = async () => {
    if (getValuesRef) {
      const values = getValuesRef as unknown as { email?: string; password?: string };
      if (values.email) {
        const email = values.email;
        await axios.post('/api/settings/resetPassword', { email })
          .then((res) => {
            // This part is for successful response
            console.log('res: ', res.data);
            if (res.data.success) {
              triggerMessage("Password changed. Check your email", false);
            } else {
              console.error('Error: ', res);
              triggerMessage("Error: Unable to change password.", true);
            }
          })
          .catch((error) => {
            // This part is for handling errors
            if (error.response) {
              // The server responded with a status code outside the 2xx range
              if (error.response.status === 404) {
                console.error('404 error: ', error.response);
                triggerMessage(error.response.data.message, true);
              } else {
                // Handle other error statuses (e.g., 500)
                console.error('Error: ', error.response);
                triggerMessage("Error: Something went wrong. Please try again later.", true);
              }
            } else if (error.request) {
              // The request was made but no response was received
              console.error('No response received: ', error.request);
              triggerMessage("Error: No response from the server. Please check your internet connection.", true);
            } else {
              // Something happened in setting up the request
              console.error('Error setting up the request: ', error.message);
              triggerMessage("Error: Something went wrong. Please try again.", true);
            }
          });
      } else {
        console.log('error')
        triggerMessage('Email is required for password recovery.', true);
      }
    } else {
      triggerMessage('Email is required for password recovery.', true);
    }
  };

  const oidc = config.data?.authConfig.methods.oidc;
  const local = config.data?.authConfig.methods.local;

  // Build OIDC URL with current redirect and share parameters
  const buildOidcUrl = () => {
    let oidcUrl = oidc?.URL || '';
    const params = [];
    if (redirect) params.push(`redirect=${encodeURIComponent(redirect)}`);
    if (shareParam) params.push(`share=${encodeURIComponent(shareParam)}`);
    if (params.length > 0) {
      oidcUrl += `?${params.join('&')}`;
    }
    return oidcUrl;
  };

  const hasLogin =
    // appSettings.data?.generalSetup.loginSetup[0].authFunctions.includes(
    appSettings.data?.loginSetup.authFunctions.includes('login');
  const hasKeyclock =
    // appSettings.data?.generalSetup.loginSetup[0].authFunctions.includes(
    appSettings.data?.loginSetup.authFunctions.includes('keyclock');
  /* const hasForgotPassword =
    // appSettings.data?.generalSetup.loginSetup[0].authFunctions.includes(
    appSettings.data?.loginSetup.authFunctions.includes('forgotPassword');
  const hasRegister =
    // appSettings.data?.generalSetup.loginSetup[0].authFunctions.includes(
    appSettings.data?.loginSetup.authFunctions.includes('register'); */

  // console.log('Register: ', hasRegister);
  // console.log('Keyclock: ', hasKeyclock);
  // console.log('Forgot Password: ', hasForgotPassword);
  // console.log('Login: ', hasLogin);

  return (
    <Box sx={{ width: '100%', maxWidth: '400px', mx: 'auto' }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, fontWeight: 500 }}>
        {t('auth.signIn')}
      </Typography>
      {oidc && hasKeyclock && (
        <Button
          variant="outlined"
          href={buildOidcUrl()}
          fullWidth
          size="large"
          sx={{ mb: 2, py: 1.5, textTransform: 'uppercase', fontSize: '0.875rem' }}
        >
          {t('auth.oidcLogin', { oidcName: oidc.name })}
        </Button>
      )}
      {oidc && local?.loginEnabled && hasLogin && hasKeyclock && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            my: 3,
          }}
        >
          <Divider sx={{ flex: 1 }} />
          <Typography color="text.secondary" sx={{ mx: 2, fontSize: '0.875rem' }}>
            {t('auth.dividerOr')}
          </Typography>
          <Divider sx={{ flex: 1 }} />
        </Box>
      )}
      {config.data?.authConfig.methods.local.loginEnabled && hasLogin && (
        <FormEL
          fields={fields}
          submitButtonTextKey="auth.signIn"
          loading={loading}
          onSubmit={handleLogin}
          exposeGetValues={setGetValuesRef}
        >
          <RememberMe
            rememberMe={rememberMe}
            onRememberMeCheckChangeHandler={onRememberMeCheckChangeHandler}
          />

          <Button
            onClick={handleForgotPasswordClick}
            variant="text"
            sx={{ textTransform: 'none', mt: -1 }}
          >
            Forgot Password
          </Button>
        </FormEL>
      )}
      {/* {config.data?.authConfig.methods.local.loginEnabled && */}
      {/*   config.data?.authConfig.methods.local.registerPath && */}
      {/*   hasRegister && ( */}
      {/*     <Box sx={{ mt: 2 }}> */}
      {/*       <Link to="register">{t('auth.signUpRef')}</Link> */}
      {/*     </Box> */}
      {/*   )} */}
    </Box>
  );
}
